import { ParagraphWrapper } from './paragraph-display.styles';

const ParagraphDisplay = ({ section }) => {
  const {
    text,
    align,
    fontSize,
    background,
    color,
    padding,
    margin,
    fontSizeMobile,
    paddingMobile,
    marginMobile
  } = section.content;

  return (
    <ParagraphWrapper
      align={align}
      fontSize={fontSize}
      background={background}
      color={color}
      padding={padding}
      margin={margin}
      fontSizeMobile={fontSizeMobile}
      paddingMobile={paddingMobile}
      marginMobile={marginMobile}
    >
      {text}
    </ParagraphWrapper>
  );
};

export default ParagraphDisplay;